module.exports = __webpack_public_path__ + "fonts/WorkSans-Black.3933192.ttf";